import { connect } from 'react-redux';
import StepFour from 'views/register/stepFour/StepFour';
import { getLoginRequest, userRegistrationBegin } from 'store/actions/auth.actions';
import { getUser, loginError, getRestoreError } from 'store/selector/auth.selector';

const mapDispatchToProps = {
  loginRequest: getLoginRequest,
  userRegistrationRequest: userRegistrationBegin
};

const mapStateToProps = (state: any) => ({
  authUser: getUser(state),
  authError: loginError(state),
  registrationError: getRestoreError(state),
});

export default connect(mapStateToProps, mapDispatchToProps)(StepFour);
